module.exports = __webpack_public_path__ + "static/media/doc6.34cb775e.jpg";